import React, {
  // useEffect,
  useContext
} from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Label, Help, Generic, Select } from "rbx";
import { Link } from "react-router-dom";

import { ModalContext } from "../ModalProvider";
import { ALL_VEHICLES_SELECT_QUERY as ALL_VEHICLES_QUERY } from "../../graphql/Vehicles/Vehicles.graphql";

const VehicleSelect = ({
  label,
  size,
  name,
  onChange,
  disabled,
  value,
  isLoading,
  showHelp,
  orderByNumber,
  required,
  firstOptionEnabled = false,
  vehicleStatus = false,
  // Vehicle,
  vehicleType
}) => {
  const where = vehicleStatus ? { StatusRecIdRef_in: vehicleStatus } : {};

  if (parseInt(vehicleType, 10)) {
    where.VehicleTypeRecIdRef = parseInt(vehicleType, 10);
  }

  const { data, loading, error } = useQuery(ALL_VEHICLES_QUERY, {
    variables: {
      where,
      orderBy: orderByNumber ? "VehicleNumber_ASC" : "Description_ASC",
      orderByMulti: orderByNumber ? ["VehicleNumber_ASC"] : ["Description_ASC"]
    }
  });

  const { setModalOpen } = useContext(ModalContext);

  // useEffect(() => {
  //   if (
  //     data &&
  //     !loading &&
  //     data.Vehicles &&
  //     Number(value) !== 0 &&
  //     ((!Vehicle && value) ||
  //       (Vehicle && Number(Vehicle.RecId) !== Number(value)))
  //   ) {
  //     const result = data.Vehicles.find(v => Number(v.RecId) === Number(value));
  //     onChange({
  //       target: { name: "Vehicle", value: result, type: "Object" }
  //     });
  //   }
  // }, [Vehicle, data, loading, onChange, value]);

  // useEffect(() => {
  //   if (
  //     data &&
  //     !loading &&
  //     data.Vehicles &&
  //     Number(value) !== 0 &&
  //     Vehicle &&
  //     value &&
  //     !parseInt(vehicleType, 10)
  //   ) {
  //     onChange({
  //       target: {
  //         name: "VehicleTypeRecIdRef",
  //         value: Vehicle.VehicleTypeRecIdRef,
  //         type: "String"
  //       }
  //     });
  //   }
  // }, [Vehicle, data, loading, onChange, value, vehicleType]);

  const getNumberLabel = vehicle =>
    value && parseInt(value) === parseInt(vehicle.RecId)
      ? vehicle.VehicleNumber
      : `${vehicle.VehicleNumber} - ${vehicle.Description}`;

  const getDescriptionLabel = vehicle =>
    value && parseInt(value) === parseInt(vehicle.RecId)
      ? vehicle.Description
      : `${vehicle.Description} - ${vehicle.VehicleNumber}`;

  const handleChange = e => {
    onChange({
      target: {
        name: e.target.name,
        value: e.target.value ? parseInt(e.target.value, 10) : ""
      }
    });
  };
  return (
    <Field>
      {showHelp && value ? (
        <Help as={Label} style={{ marginTop: 0 }}>
          <Generic
            as={Link}
            tabIndex="-1"
            textColor="link"
            to={`/fleet/vehicles/${value}/profile`}
            onClick={() => setModalOpen(false)}
          >
            {label}
          </Generic>
        </Help>
      ) : (
        <Label size={size}>{label}</Label>
      )}

      <Select.Container
        fullwidth
        color={
          error || (required && (value === "" || value === "0" || value === 0))
            ? "danger"
            : "secondary"
        }
        size={size}
        state={loading || !data ? "loading" : undefined}
      >
        <Select
          disabled={disabled}
          isloading={loading.toString() || isLoading.toString()}
          name={name}
          value={value}
          onChange={handleChange}
        >
          {firstOptionEnabled && (
            <Select.Option value={0}>Select...</Select.Option>
          )}
          {Array.isArray(data?.Vehicles) &&
            data.Vehicles.map((vehicle, i) => (
              <Select.Option key={i} value={vehicle.RecId}>
                {orderByNumber
                  ? getNumberLabel(vehicle)
                  : getDescriptionLabel(vehicle)}
              </Select.Option>
            ))}
        </Select>
      </Select.Container>
    </Field>
  );
};

VehicleSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  showHelp: PropTypes.bool,
  orderByNumber: PropTypes.bool,
  required: PropTypes.bool,
  firstOptionEnabled: PropTypes.bool,
  vehicleStatus: PropTypes.array,
  // Vehicle: PropTypes.object,
  vehicleType: PropTypes.string
};

VehicleSelect.defaultOptions = {
  isLoading: null,
  firstOptionEnabled: false,
  vehicleType: ""
};

VehicleSelect.displayName = "VehicleSelect";

export default VehicleSelect;
